import alexPhoto from 'assets/avatars/tiktok.jpg';
import thandiPhoto from 'assets/avatars/instagram.jpg';
import youPhoto from 'assets/avatars/profile-avatar.jpg';

import * as styled from '../styles/marketplace-frame';

const DEMO_QUERY = 'house cleaning';
const DEMO_TRADE = 'House Cleaner';

export const MarketplaceFrame = () => (
  <styled.Frame>
    <styled.FrameBar>
      <styled.FrameLogo>kudable</styled.FrameLogo>
    </styled.FrameBar>
    <styled.SearchPill>
      <styled.SearchIcon aria-hidden>🔍</styled.SearchIcon>
      {DEMO_QUERY}
    </styled.SearchPill>
    <styled.ResultRow>
      <styled.ResultAvatar>
        <styled.ResultPhoto src={thandiPhoto} alt="" />
      </styled.ResultAvatar>
      <styled.ResultText>
        <styled.ResultName>Thandi M.</styled.ResultName>
        <styled.ResultTrade>{DEMO_TRADE}</styled.ResultTrade>
      </styled.ResultText>
      <styled.ResultRating>★ 4.8</styled.ResultRating>
    </styled.ResultRow>
    <styled.ResultRow $you>
      <styled.ResultAvatar $you>
        <styled.ResultPhoto src={youPhoto} alt="" />
      </styled.ResultAvatar>
      <styled.ResultText>
        <styled.ResultName>
          You
          <styled.YouBadge>Your profile</styled.YouBadge>
        </styled.ResultName>
        <styled.ResultTrade>{DEMO_TRADE}</styled.ResultTrade>
      </styled.ResultText>
      <styled.ResultRating>★ 5.0</styled.ResultRating>
    </styled.ResultRow>
    <styled.ResultRow>
      <styled.ResultAvatar>
        <styled.ResultPhoto src={alexPhoto} alt="" />
      </styled.ResultAvatar>
      <styled.ResultText>
        <styled.ResultName>Alex P.</styled.ResultName>
        <styled.ResultTrade>{DEMO_TRADE}</styled.ResultTrade>
      </styled.ResultText>
      <styled.ResultRating>★ 4.6</styled.ResultRating>
    </styled.ResultRow>
  </styled.Frame>
);
